import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {
  like: '',
  id: '',
  descricao: '',
  plano: [],
  conta: '',
  inivalid: { i: null, f: null },
  fimvalid: { i: null, f: null },
};

export const PlanocontaContext = createContext();

export const PlanocontaProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [planoconta, setPlanoconta] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getPlanoconta = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: planoconta?.filter,
        page: planoconta?.page,
        size: planoconta?.size,
        order: planoconta?.order,
        ...payload,
      });
      setPlanoconta((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <PlanocontaContext.Provider
      value={{
        getLoading,
        planoconta,
        getPlanoconta,
      }}
    >
      {children}
    </PlanocontaContext.Provider>
  );
};
